import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlConsultaDiarias = '/service/contabilidade/dotacao/'

class ConsultaRestosPagar extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join() : this.state.adms,
            mes: filtro.mes && filtro.mes.value < 10 ? filtro.exercicio.value + '0' + filtro.mes.value : filtro.exercicio.value + filtro.mes.value,
            nome: filtro.nome ? filtro.nome : null,
            cpf: filtro.cpf ? filtro.cpf.replace(/^(\d{3}).(\d{3}).(\d{3})-(\d{2})/, '$1$2$3$4') : null,
            cargo: filtro.cargo.length !== 0 ? filtro.cargo.map(e => e.value).join() : null,
        }
        return this.conex.post(urlConsultaDiarias + 'consultaPagamentoContraCheque/', JSON.stringify(data))
    }
}

export default ConsultaRestosPagar
